import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { MapPin, Calendar, Users, Sparkles } from 'lucide-react';
export const EventDetailsSection = () => {
  const sectionRef = useRef<HTMLElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: sectionRef,
    offset: ['start end', 'end start']
  });
  const opacity = useTransform(scrollYProgress, [0, 0.2, 0.8, 1], [0, 1, 1, 0]);
  return <motion.section id="details" ref={sectionRef} className="py-20 md:py-28 bg-black relative overflow-hidden" style={{
    opacity
  }} data-id="element-362">
      <div className="absolute inset-0 bg-gradient-to-b from-amber-950/10 to-black/60 z-0" data-id="element-363"></div>
      <div className="container mx-auto px-4 relative z-10" data-id="element-364">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-24" data-id="element-365">
          <p className="text-amber-400/60 tracking-[0.3em] text-xs uppercase mb-6" data-id="element-366">
            Essential Information
          </p>
          <h2 className="font-serif text-5xl md:text-7xl text-white mb-8" data-id="element-367">
            EVENT
            <br data-id="element-368" />
            <span className="text-amber-400" data-id="element-369">DETAILS</span>
          </h2>
          <div className="w-24 h-px bg-amber-400/30 mx-auto" data-id="element-370"></div>
        </motion.div>
        <div className="max-w-6xl mx-auto" data-id="element-371">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-16" data-id="element-372">
            {/* Venue Card */}
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} data-id="element-373">
              <div className="relative" data-id="element-374">
                <div className="aspect-video relative overflow-hidden mb-8 rounded-lg" data-id="element-375">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kppHXez1XGBnRYW5bwUDVX/illumiarium.png" alt="Illuminarium Venue" className="w-full h-full object-contain bg-black" data-id="element-376" />
                </div>
                <div className="space-y-8" data-id="element-377">
                  <div className="flex items-start" data-id="element-378">
                    <MapPin className="w-6 h-6 text-amber-400 mr-4 flex-shrink-0 mt-1" data-id="element-379" />
                    <div data-id="element-380">
                      <h4 className="font-serif text-2xl text-amber-400 mb-3" data-id="element-381">
                        Venue
                      </h4>
                      <p className="text-white/80 font-light leading-relaxed" data-id="element-382">
                        Illuminarium Toronto
                        <br data-id="element-383" />
                        123 Experience Drive
                        <br data-id="element-384" />
                        Toronto, ON M5V 2K4
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start" data-id="element-385">
                    <Calendar className="w-6 h-6 text-amber-400 mr-4 flex-shrink-0 mt-1" data-id="element-386" />
                    <div data-id="element-387">
                      <h4 className="font-serif text-2xl text-amber-400 mb-3" data-id="element-388">
                        Dates
                      </h4>
                      <p className="text-white/80 font-light leading-relaxed" data-id="element-389">
                        Spring 2026
                        <br data-id="element-390" />
                        Doors open at 6:00 PM
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
            {/* Details Card */}
            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="flex flex-col justify-between space-y-8" data-id="element-391">
              <div className="space-y-8" data-id="element-392">
                <div className="flex items-start" data-id="element-393">
                  <Users className="w-6 h-6 text-amber-400 mr-4 flex-shrink-0 mt-1" data-id="element-394" />
                  <div data-id="element-395">
                    <h4 className="font-serif text-2xl text-amber-400 mb-3" data-id="element-396">
                      Capacity
                    </h4>
                    <p className="text-white/80 font-light leading-relaxed" data-id="element-397">
                      Limited & exclusive seating
                      <br data-id="element-398" />
                      Only 120 guests per evening
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-399">
                  <Sparkles className="w-6 h-6 text-amber-400 mr-4 flex-shrink-0 mt-1" data-id="element-400" />
                  <div data-id="element-401">
                    <h4 className="font-serif text-2xl text-amber-400 mb-3" data-id="element-402">
                      Format
                    </h4>
                    <p className="text-white/80 font-light leading-relaxed" data-id="element-403">
                      Sikh Foundation Centennial Gala experience
                      <br data-id="element-404" />
                      Immersive dining and cultural showcase
                    </p>
                  </div>
                </div>
              </div>
              <div className="border border-amber-400/30 p-8 bg-black/40" data-id="element-405">
                <h3 className="font-serif text-3xl text-amber-400 mb-4" data-id="element-406">
                  Spring 2026
                </h3>
                <p className="text-white/70 font-light mb-4 leading-relaxed" data-id="element-407">
                  The exclusive experience takes place Spring 2026. All ticket
                  holders receive admission to this premiere experience.
                </p>
                <div className="w-full h-px bg-white/10 my-6" data-id="element-408"></div>
                <h4 className="text-xl text-amber-400 font-light mb-3" data-id="element-409">
                  Monthly Experiences
                </h4>
                <p className="text-white/70 font-light mb-6 leading-relaxed" data-id="element-410">
                  Your ticket also grants access to one monthly experience
                  between May and December 2026. Choose your preferred date when
                  finalizing your reservation.
                </p>
                <div className="flex justify-between items-center pt-4 border-t border-white/10" data-id="element-411">
                  <span className="text-amber-400 font-light tracking-wider" data-id="element-412">
                    Spring 2026
                  </span>
                  <span className="text-white/60 text-sm tracking-wider uppercase" data-id="element-413">
                    Premiere Event
                  </span>
                </div>
                <div className="flex justify-between items-center pt-3" data-id="element-414">
                  <span className="text-amber-400 font-light tracking-wider" data-id="element-415">
                    May - Dec 2026
                  </span>
                  <span className="text-white/60 text-sm tracking-wider uppercase" data-id="element-416">
                    Monthly Access
                  </span>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
        {/* Bottom Quote */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="text-center mt-24" data-id="element-417">
          <p className="text-xl text-white/70 italic font-light max-w-3xl mx-auto" data-id="element-418">
            "Mark your calendars for two unforgettable evenings of history,
            culture, and culinary excellence."
          </p>
        </motion.div>
      </div>
    </motion.section>;
};